import React from 'react';
import { NavLink } from 'react-router';

import { Box, Divider, Typography, Theme } from '@mui/material';

export interface NavItem {
	path: string;
	label: string;
	icon: React.ComponentType<{ className?: string }>;
	isActive: (pathname: string) => boolean;
	iconWrapperSx?: object;
	redirectCallback?: () => void
	iconOnly?: boolean;
}

export interface NavItemComponentProps {
	item: NavItem;
	currentPathname: string;
	theme: Theme;
	isMobile: boolean;
	iconWrapperSx?: object;
	dividerSx: object;
	disableNav?: boolean;
	redirectCallback?: ()=> void
	hideDivider?: boolean;
}

const NavItemComponent: React.FC<NavItemComponentProps> = ({
	item,
	currentPathname,
	theme,
	isMobile,
	iconWrapperSx = {},
	dividerSx = {},
	disableNav,
	redirectCallback,
	hideDivider
}) => {
	const isActive = item.isActive(currentPathname);
	const Icon = item.icon;
	const showLabel = !isMobile && !item.iconOnly;

	return (
		<>
			<Box
				component={disableNav ? Box : NavLink}
				to={item.path}
				sx={{
					display: 'flex',
					alignItems: 'center',
					cursor: 'pointer',
					py: 2,
					px: item.iconOnly ? 3 : (isMobile ? 2 : 4),
					textDecoration: 'none',
					transition: 'border-color 0.2s',
					borderBottom: isActive ? `3px solid ${theme.palette.custom.brandTeal}` : 'none',
					height: '100%',
					"&:hover": {
						opacity: 0.8
					}
				}}
				onClick={redirectCallback}
			>
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						'& svg': { width: 20, height: 20 },
						...iconWrapperSx,
						color: isActive ? theme.palette.custom.brandTeal : theme.palette.text.secondary,
					}}
				>
					<Icon className="" />
				</Box>

				{showLabel && (
					<Typography
						variant="subtitle1"
						sx={{
							ml: 2,
							color: theme.palette.text.primary,
							fontWeight: 500,
						}}
					>
						{item.label}
					</Typography>
				)}
			</Box>

			{!hideDivider && <Divider orientation="vertical" flexItem sx={dividerSx} />}
		</>
	);
};

export default NavItemComponent;

